<template>
  <div class="columns is-multiline is-marginless is-main-content is-paddingless"
  v-if="critereRecherche">
    <div class="column is-12 pdb-0 hauteur-haut-brief-filtre">
      <div class="column is-12 mgt-5px">
        <a @click="$emit('toggleFiltre')">
          <b-icon class="icon is-pulled-right has-text-icon-more" icon="close"></b-icon>
        </a>
        <span class="has-text-weight-bold is-size-4">
          {{ $t('listeFournisseurSupport.filtre.title') }}
        </span>
      </div>
      <div class="column is-12 pdt-0">
        <span class="has-text-icon-more is-size-7">
          {{ $t('listeFournisseurSupport.filtre.sousTitle') }}
        </span>
      </div>
    </div>
    <div class="column is-12 is-marginless overflow-auto hauteur-brief-filtre">
      <div class="columns is-marginless is-multiline">
        <div class="column is-12 pdb-0">
          <b-field :label="$t('listeFournisseurSupport.filtre.fournisseurs')">
            <qd-taginput
              v-model="critereRecherche.tiers"
              :data="filteredTagsTiers"
              :loading="isFetchingTiers"
              @typing="getfilteredTiers"
              autocomplete
              icon="magnify"
              type="is-primary"
              field="nomCommercial">
              <template slot-scope="props">
                {{ props.option.nomWithAdresse }}
              </template>
              <template slot="empty">
                <div v-if="!isFetchingTiers">
                  {{$t('general.autocomplete.noRslt')}}
                </div>
              </template>
            </qd-taginput>
          </b-field>
        </div>
        <div class="column is-12 pdb-0">
          <b-field :label="$t('listeFournisseurSupport.filtre.ville')">
            <ville-tag-input-auto-complete
              :critere-recherche="this.critereRecherche"
              table-name="Tiers"/>
          </b-field>
        </div>
        <div class="column is-12 pdb-0">
          <b-field :label="$t('listeFournisseurSupport.filtre.blocageReglement')">
            <b-select v-model="critereRecherche.blocageReglement">
              <option :value="null"></option>
              <option :value="true"> {{ $t('listeFournisseurSupport.filtre.yes') }}
              </option>
              <option :value="false"> {{ $t('listeFournisseurSupport.filtre.no') }}
              </option>
            </b-select>
          </b-field>
        </div>
        <div class="column is-12">
          <b-field :label="$t('listeFournisseurSupport.filtre.motifBlocage')">
            <qd-taginput
              v-if="motifTags"
              v-model="motifSelected"
              :data="motifTags"
              @typing="getFilteredMotifTags"
              @input="getMotifTag"
              type="is-primary"
              icon="magnify"
              field="libelle"
              autocomplete
              open-on-focus>
            </qd-taginput>
          </b-field>
        </div>
        <div class="column is-12 pdb-0">
          <b-field :label="$t('listeFournisseurSupport.filtre.compteComptable')">
            <b-input v-model="critereRecherche.compteComptable"></b-input>
          </b-field>
        </div>
        <div class="column is-12 pdb-0">
          <b-field :label="$t('listeFournisseurSupport.filtre.email')">
            <b-input v-model="critereRecherche.email"></b-input>
          </b-field>
        </div>
        <div class="column is-12 pdb-0">
          <b-field :label="$t('listeFournisseurSupport.filtre.telephone')">
            <b-input v-model="critereRecherche.telephone"></b-input>
          </b-field>
        </div>
        <div class="column is-12 pdb-0">
          <b-field :label="$t('listeFournisseurSupport.filtre.archive')">
            <b-select v-model="critereRecherche.archive">
              <option :value="null"></option>
              <option :value="true"> {{ $t('listeFournisseurSupport.filtre.yes') }}
              </option>
              <option :value="false"> {{ $t('listeFournisseurSupport.filtre.no') }}
              </option>
            </b-select>
          </b-field>
        </div>
      </div>
    </div>
    <div class="column is-12 border-pied pdt-0 hauteur-bas-brief-filtre">
      <button
        class="button mgl-10px mgt-10px is-addOrEdit has-text-white"
        @click="appliquerCritere()">
        {{$t('listeFournisseurSupport.filtre.actions.appliquer')}}
      </button>
      <button
        class="button border-none mgt-10px has-text-icon-more pd-10px"
        @click="viderCritere()">
        {{$t('listeFournisseurSupport.filtre.actions.reinitialiser')}}
      </button>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import debounce from 'lodash/debounce';
import cloneDeep from 'lodash/cloneDeep';
import genererCritereRecherche from '@/services/achat/fournisseurSupport/genererCritereRechercheFournisseurSupport';
import { SET_CRITERE_RECHERCHE } from '@/store/modules/achat/fournisseurSupport-mutation-type';
import {
  TIERS_TYPE_FOURNISSEUR,
  TIERS_SOUS_TYPE_FOURNISSEUR_SUPPORT,
} from '@/configuration/tiers/tiersConf';
import * as typesParametres from '@/store/modules/parametres-mutation-type';
import messageErreur from '@/services/general/messageErreur';
import VilleTagInputAutoComplete from '@/components/commun/ville/villeTagInputAutoComplete';
import { getAll as getAllTiers } from '@/api/tiers/index';
import adressFullStringGetter from '@/services/general/adressFullStringGetter';

const FournisseurSupport = createNamespacedHelpers('fournisseurSupport');
const Parametres = createNamespacedHelpers('parametres');
const Societe = createNamespacedHelpers('societe');

export default {
  components: {
    VilleTagInputAutoComplete,
  },
  data() {
    return {
      critereRecherche: null,
      filteredTagsTiers: [],
      isFetchingTiers: false,
      motifTags: null,
      listeMotifBase: [],
      motifSelected: [],
    };
  },
  computed: {
    ...Parametres.mapGetters({
      parametre: 'parametre',
    }),
    ...FournisseurSupport.mapGetters({
      critereRechercheFromStore: 'criteresRecherche',
    }),
    ...Societe.mapGetters({
      societeActiveId: 'societeActiveId',
    }),
    motifBlocage() {
      return this.parametre(typesParametres.PARAMETRES_KEYS
        .motifBlocage).filter(motif => motif.actif);
    },
  },
  methods: {
    ...FournisseurSupport.mapMutations({
      setCritereRecherche: SET_CRITERE_RECHERCHE,
    }),
    ...Parametres.mapActions({
      loadParametres: 'loadParametres',
    }),
    getFilteredMotifTags(text) {
      this.getMotifTag();
      this.motifTags = this.motifTags.filter((motif) => {
        return motif.libelle.toLowerCase().indexOf(text.toLowerCase()) >= 0;
      });
    },
    getMotifTag() {
      this.motifTags = this.listeMotifBase.filter((nature) => {
        return !this.motifSelected.map(a => a.id).includes(nature.id);
      });
    },
    viderCritere() {
      const critereRecherche = genererCritereRecherche();

      const sousTypeList = [];
      critereRecherche.sousType = sousTypeList;
      this.motifSelected = [];
      this.critereRecherche = critereRecherche;
    },
    appliquerCritere() {
      this.critereRecherche.motifsBlocagesId = this.motifSelected.map(el => el.id);
      this.setCritereRecherche(this.critereRecherche);
      this.$emit('recherche');
    },
    getfilteredTiers: debounce(async function getTiers(search) {
      this.filteredTagsTiers = [];
      if (!search) return;
      this.isFetchingTiers = true;
      try {
        const tiers = (await getAllTiers({
          query: {
            nomsCommercialOuNomsJuridique: [search],
            societeId: this.societeActiveId,
            type: TIERS_TYPE_FOURNISSEUR,
            sousType: [
              TIERS_SOUS_TYPE_FOURNISSEUR_SUPPORT,
            ],
          },
        })).data.result.items;
        tiers.forEach((el) => {
          el.nomWithAdresse = el.nomCommercial;
          if (adressFullStringGetter(el.adressePostale, false) !== '') {
            el.nomWithAdresse += ' - ' + adressFullStringGetter(el.adressePostale, false);
          }
        });
        this.filteredTagsTiers = tiers
          .filter((el) => !this.critereRecherche.tiers.map(el => el.id).includes(el.id));
        this.isFetchingTiers = false;
      } catch (e) {
        this.isFetchingTiers = false;
        messageErreur(this.$i18n);
        throw (e);
      }
    }, 300),
    async initializeFiltre() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        this.critereRecherche = cloneDeep(this.critereRechercheFromStore);
        await this.loadParametres([
          typesParametres.PARAMETRES_KEYS.motifBlocage,
        ]);
        this.listeMotifBase = this.motifBlocage;
        if (this.critereRecherche.motifsBlocagesId) {
          this.motifSelected = this.listeMotifBase.filter((c) => {
            return this.critereRecherche.motifsBlocagesId.includes(c.id);
          });
        }
        this.getMotifTag();
        loadingComponent.close();
      } catch (e) {
        loadingComponent.close();
        messageErreur(this.$i18n);
        throw e;
      }
    },
  },
  mounted() {
    this.initializeFiltre();
  },
};
</script>
